export const minmax = (x: number, min: number, max: number) =>
  Math.max(min, Math.min(max, x));
